import { LocaleObject, setLocale } from "yup";
export const useLocalizedYupSchema = () => {
  setLocale({
    mixed: mixed,
    string: string,
    array: array,
    boolean: boolean,
    date: date,
    number: number,
    object: object,
  });
};

// Based on https://github.com/jquense/yup/blob/b940eef48eb7456622ae384d0ffa7363d4fbad25/src/locale.ts
export const mixed: LocaleObject["mixed"] = {
  default: "Không hợp lệ.",
  required: "Là một trường bắt buộc",
  defined: "Phải được xác định",
  notNull: "Không thể là NULL",
  oneOf: "Phải là một trong các giá trị sau: ${values}",
  notOneOf: "Không được là một trong các giá trị sau: ${values}",
  notType: ({ path, type, value, originalValue }) => {},
};

export const string: LocaleObject["string"] = {
  length: "Phải chính xác là ${length} ký tự",
  min: "Phải ít nhất ${min} ký tự",
  max: "Không được vượt quá ${max} ký tự",
  matches: 'phải phù hợp như sau: "${regex}"',
  email: "Phải là một email hợp lệ",
  url: "Phải là một URL hợp lệ",
  uuid: "Phải là UUID hợp lệ",
  trim: "Phải là một chuỗi được cắt",
  lowercase: "Phải là chuỗi chữ thường",
  uppercase: "Phải là chuỗi trường hợp trên",
};

export const number: LocaleObject["number"] = {
  min: "Phải lớn hơn hoặc bằng ${min}",
  max: "Phải nhỏ hơn hoặc bằng ${max}",
  lessThan: "Phải nhỏ hơn ${less}",
  moreThan: "Phải lớn hơn ${more}",
  positive: "Phải là một số dương",
  negative: "Phải là số âm",
  integer: "Phải là một số nguyên",
};

export const date: LocaleObject["date"] = {
  min: "Phải lớn hơn ${min}",
  max: "Phải nhỏ hơn ${max}",
};

export const boolean: LocaleObject["boolean"] = {
  isValue: "Phải là ${value}",
};

export const object: LocaleObject["object"] = {
  noUnknown:
    "Trường không thể có các khóa không được chỉ định trong hình dạng đối tượng",
};

export const array: LocaleObject["array"] = {
  min: "Phải có ít nhất ${min} các mục",
  max: "Phải có ít hơn hoặc bằng các mục ${max}",
  length: "Phải có ${length} các mục",
};
